import { Text, Textarea } from '@chakra-ui/react';
import { useState } from 'react';
import { UseFormReturn, useFormContext } from 'react-hook-form';
import { MESSAGE_MAX_LENGTH } from '~/constants/tipping_message';
import { useI18nLn } from '~/hooks/store';
import {
  AccordionItem,
  AccordionItemContent,
  AccordionItemTrigger,
  AccordionRoot,
} from '../ui/accordion';
import { Field } from '../ui/field';

export const TippingMessageForm: React.FC<{
  form: UseFormReturn<{ tippingMessage: string }>;
}> = ({ form }) => {
  const [characterCount, setCharacterCount] = useState(0);
  const { register } = useFormContext();
  const { t } = useI18nLn();
  return (
    <AccordionRoot collapsible border="white" value={['tippingMessage']}>
      <AccordionItem value="tippingMessage">
        <AccordionItemTrigger>
          <Text justifyContent="center" fontSize="16px" fontWeight="bold">
            {t('pages.buy.tipping_message.title')}
          </Text>
        </AccordionItemTrigger>
        <AccordionItemContent>
          <Field
            invalid={!!form.formState.errors.tippingMessage}
            errorText={form.formState.errors.tippingMessage?.message}
          >
            <Textarea
              variant="subtle"
              placeholder={t('pages.buy.tipping_message.placeholder')}
              maxLength={MESSAGE_MAX_LENGTH}
              {...register('tippingMessage')}
              onChange={(e) => {
                setCharacterCount(e.target.value.length);
                form.setError('tippingMessage', {
                  message:
                    e.target.value.length > MESSAGE_MAX_LENGTH
                      ? t('pages.buy.tipping_message.invalid_length')
                      : undefined,
                });
              }}
            />
          </Field>
          <Text fontSize="12px" color="gray.500">
            {`${characterCount} / ${MESSAGE_MAX_LENGTH}`}
          </Text>
          {form.formState.errors.tippingMessage != undefined && (
            <Field>{form.formState.errors.tippingMessage.message}</Field>
          )}
          <Text mt="8px" fontSize="12px" color="red">
            {t('pages.buy.tipping_message.caution')}
          </Text>
        </AccordionItemContent>
      </AccordionItem>
    </AccordionRoot>
  );
};
